<template>
  <div>
    <h5
      v-if="showTitle"
      class="text-h5 q-mt-none q-mb-xs"
      :class="textColor"
    >
      {{ $t('movie.overview') }}
    </h5>
    <!-- eslint-disable vue/no-v-html -->
    <!-- v-html produced by tool -->
    <div
      ref="synopsisRef"
      :class="{
        'ellipsis-3-lines': !isExpanded && isTruncated ,
        [textColor]: true
      }"
      v-html="findMovieBySlug.synopsisWithBreaks"
    />
    <q-btn
      v-if="isTruncated"
      flat
      padding="none"
      size="md"
      class="block q-mt-sm"
      :class="textColor"
      @click="isExpanded = !isExpanded"
    >
      <span v-if="!isExpanded">{{ $t('nav.actions.readMore') }} <span class="material-icons"> expand_more</span></span>
      <span v-else>{{ $t('nav.actions.readLess') }} <span class="material-icons"> expand_less</span></span>
    </q-btn>

    <template v-if="findMovieBySlug.ratingReason">
      <h5
        class="text-h5 q-mt-sm q-mb-none"
        :class="textColor"
      >
        {{ $t('movie.movieRating') }}
      </h5>
      <div
        :class="textColor"
        v-html="findMovieBySlug.ratingReason"
      />
    </template>
    <template v-if="findMovieBySlug.directedBy">
      <h5
        class="text-h5 q-mt-sm q-mb-none"
        :class="textColor"
      >
        {{ $t('movie.director') }}
      </h5>
      <div
        :class="textColor"
        v-html="findMovieBySlug.directedBy"
      />
    </template>
    <template v-if="findMovieBySlug.producedBy">
      <h5
        class="text-h5 q-mt-sm q-mb-none"
        :class="textColor"
      >
        {{ $t('movie.producer') }}
      </h5>
      <div
        :class="textColor"
        v-html="findMovieBySlug.producedBy"
      />
    </template>
    <template v-if="findMovieBySlug.starring">
      <h5
        class="text-h5 q-mt-sm q-mb-none"
        :class="textColor"
      >
        {{ $t('movie.cast') }}
      </h5>
      <div
        :class="textColor"
        v-html="findMovieBySlug.starring"
      />
    </template>
    <slot name="showingBadges" />
  </div>
</template>

<script>
import MovieSlugMixin from 'src/modules/consumer/components/mixins/MovieSlugMixin'
export default {
  name: 'MovieOverview',
  mixins: [MovieSlugMixin],
  props: {
    showTitle: {
      type: Boolean,
      default: false
    },
    textColor: {
      type: String,
      default: undefined
    }
  },
  data () {
    return {
      isExpanded: false,
      isTruncated: false
    }
  },
  watch: {
    'findMovieBySlug.synopsisWithBreaks': {
      immediate: true,
      handler () {
        this.$nextTick(this.checkIfTruncated)
      }
    }
  },
  mounted () {
    this.checkIfTruncated()
  },
  methods: {
    checkIfTruncated () {
      const el = this.$refs.synopsisRef
      if (!el) return

      const lineHeight = parseFloat(getComputedStyle(el).lineHeight)
      const maxHeight = lineHeight * 3
      this.isTruncated = el.scrollHeight > maxHeight
    }
  }
}
</script>
